import React from "react";
import GroupMenuComp from "../../components/GroupMenu/GroupMenu";
const GroupMenu = () => {
  return (
    <div>
      <GroupMenuComp />
    </div>
  );
};

export default GroupMenu;
